import {
  ContextualMenuItemType,
  DirectionalHint,
  IButtonProps,
  IconButton,
  Shimmer,
  Stack,
  TooltipHost
} from "@fluentui/react";
import { useMemo } from "react";
import { METRICS_HEADER } from "../Constants/MetricsHeader.constant";
import {
  classNames,
  contextualMenuStyles,
  horizontalBarHeaderShimmerStyles
} from "../Styles/CustomCardWithMetrics.styles";
import { AppliedFilters } from "./AppliedFilters";

// Header component
export const MetricsHeader = ({
  title,
  isLoading,
  metricFilters,
  onResetFilters
}: {
  title?: string;
  isLoading: boolean;
  metricFilters: { [key: string]: any };
  onResetFilters: () => void;
}) => {
  const hasFilters = useMemo(() => Object.keys(metricFilters).length > 0, [metricFilters]);

  const iconButtonProps: IButtonProps = {
    ariaLabel: METRICS_HEADER.ARIA_LABEL_APPLIED_FILTERS,
    menuProps: {
      directionalHint: DirectionalHint.bottomRightEdge,
      items: [
        {
          key: METRICS_HEADER.MENU_SELECTED_FILTERS_HEADER_KEY,
          itemType: ContextualMenuItemType.Header,
          text: METRICS_HEADER.MENU_SELECTED_FILTERS_HEADER_TEXT,
          itemProps: {
            styles: {
              label: `${classNames.layoutText} ${classNames.headerLabel}`
            }
          }
        },
        {
          key: METRICS_HEADER.MENU_SELECTED_FILTERS_CONTEXT_KEY,
          onRender: () => <AppliedFilters metricFilters={metricFilters} />
        }
      ],
      styles: contextualMenuStyles
    },
    title: METRICS_HEADER.MENU_TITLE
  };

  if (isLoading) {
    return <Shimmer styles={horizontalBarHeaderShimmerStyles} />;
  }

  return (
    <Stack horizontal styles={{ root: { alignItems: "center", justifyContent: "space-between" } }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <span>{title}</span>
      </div>
      {hasFilters && (
        <Stack horizontal>
          <TooltipHost content={METRICS_HEADER.TOOLTIP_CLEAR_ALL} calloutProps={{ gapSpace: 0 }}>
            <IconButton
              iconProps={{ iconName: METRICS_HEADER.ICON_CLEAR_FILTER }}
              ariaLabel="Clear All Filters"
              onClick={onResetFilters}
            />
          </TooltipHost>
          <TooltipHost content={METRICS_HEADER.TOOLTIP_FILTERS_IN_USE} calloutProps={{ gapSpace: 0 }}>
            <IconButton {...iconButtonProps} />
          </TooltipHost>
        </Stack>
      )}
    </Stack>
  );
};
